var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 12a12 12 0 10-13.9 12v-8.5h-3v-3.4h3V9.4c0-3 1.8-4.6 4.6-4.6l2.6.2v3h-1.5c-1.5 0-2 .9-2 1.8v2.3h3.4l-.5 3.4h-2.8V24A12 12 0 0024 12.1z"}));
}

Facebook.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Facebook;

Facebook.default = Facebook;
